import { render, staticRenderFns } from "./InformeGestion.vue?vue&type=template&id=1e150be8&"
import script from "./InformeGestion.vue?vue&type=script&lang=js&"
export * from "./InformeGestion.vue?vue&type=script&lang=js&"
import style0 from "./InformeGestion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports